// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

export const ComponentReviewCarouselFragmentDoc = `
    fragment componentReviewCarousel on ComponentReviewCarousel {
  reviews {
    author
    date
    review
    starsCount
  }
}
    `;